
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/firms/rj",
      function () {
        return require("private-next-pages/firms/rj.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/firms/rj"])
      });
    }
  